import React, { Component } from "react";
import { withRouter, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import { withApollo, Query } from "react-apollo";
import { Col, Row, Container } from "reactstrap";
import { signout } from "../../redux/actions/userActions";
import {
  GetSRASectionQuestions,
  SubmitSRASectionAnswer
} from "../../queries/assessment";
import LinearProgress from "@material-ui/core/LinearProgress";
import { withStyles } from "@material-ui/core/styles";
import DataLoader from "../../app/DataLoader";
import { loader as Loader } from "../Loader";
import { saving as Saving } from "../Saving";
import RiskQuestion from "./components/RiskQuestion";
import SliderQuestion from "./components/SliderQuestion";
import NavigationButtons from "./components/NavigationButtons";

class SRASectionPage extends Component {
  state = {
    questions: {},
    mainQuestions: [], //all non-slider questions
    activeMainQuestions: [], //subset of main questions that are enabled
    subQuestions: {}, //represents all slider questions
    activeSubQuestions: {}, //subset of slider questions that are enabled
    sectionName: null, //Section Name
    backendSectionName: null, //sra:section-name
    sectionNumber: null, //1,2,3...
    pageDataReady: false, //indicates when component state has been completely configured
    sectionProgress: 0, //represents percentage of questions done
    redirectNext: false, // indicates if we should redirect to the next section
    redirectBack: false, // indicates if we should redirect the SRA Overview page
    redirectPrev: false, // indicates if we should redirect to a previous section
    nextPage: {}, // contains the routing data for the next section
    prevPage: {}, // contains the routing data for the previous section
    saving: false // indicates when data is being saved
  };

  /**
   * Setups data to be used on the page.
   *
   * questionData - Data retrieved from GetSRAQuestions Query
   * nextQuestionID - The next question that should be scrolled to
   * routingData - Contains section information for the current page (sectionName,
   * backendSectionName, sectionNumber)
   */
  setupPageData = (
    questionData,
    nextQuestionID = null,
    routingData = this.props.location.state
  ) => {
    let questions = JSON.parse(JSON.stringify(questionData));

    const {
      mainQuestions,
      subOrderedQuestions: subQuestions,
      activeMainQuestions,
      activeSubQuestions
    } = this.splitQuestions(questions);
    const sectionProgress = this.calculateSectionProgress(
      activeMainQuestions,
      activeSubQuestions
    );

    // console.log(questionData);
    // console.log(questions);
    // console.log(mainQuestions);
    // console.log(activeMainQuestions);
    // console.log(subQuestions);
    // console.log(activeSubQuestions);
    // console.log(sectionProgress);

    this.setState(
      {
        sectionNumber: routingData.sectionNumber,
        sectionName: routingData.sectionName,
        backendSectionName: routingData.backendSectionName,
        pageDataReady: true,
        mainQuestions,
        subQuestions,
        activeMainQuestions,
        sectionProgress,
        questions,
        activeSubQuestions
      },
      () => {
        //scroll to question if nextQuestionID exists
        if (nextQuestionID) {
          document
            .querySelector(`.risk__questions.risk_${nextQuestionID}`)
            .scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }
    );
  };

  /**
   * Based on the question data from the backend, this function
   * is responsible for determining which questions are enabled/disabled
   * and seperates them into 3 broad categories: radio type, checkbox type
   * & slider type questions.
   */
  splitQuestions = questions => {
    let mainQuestions = [];
    let subUnOrderedQuestions = {};
    let subOrderedQuestions = {};
    let activeMainQuestions = [];
    let activeMainQuestionIds = [];
    let unOrderedActiveSubQuestions = {};
    let activeSubQuestions = {};
    let checkBoxQuestionKey = null;
    let _questions = JSON.parse(JSON.stringify(questions));

    // Decides what questions are active or not. Also separates main questions from sub questions.
    Object.keys(_questions).forEach((key, questionIndex) => {
      let currentQuestion = JSON.parse(JSON.stringify(_questions[key]));
      // console.log(currentQuestion);
      if (/[0-9]*[a-z]/.test(key)) {
        //sub questions
        subUnOrderedQuestions[key] = {};
        subUnOrderedQuestions[key].answers = _questions[key];
        subUnOrderedQuestions[key].question = "";
      } else {
        if (currentQuestion.questionType === "checkbox") {
          checkBoxQuestionKey = key;
          currentQuestion.disabled = false; //checkbox question is always enabled
          activeMainQuestions.push(currentQuestion); //add any checkbox question
          activeMainQuestionIds.push(currentQuestion.questionID);
        } else if (currentQuestion.questionType === "radio") {
          if (questionIndex === 0) {
            //scenario 1: first radio button always enabled
            activeMainQuestionIds = this.addActiveQuestions(
              currentQuestion,
              activeMainQuestionIds
            );
            currentQuestion.disabled = false;
            _questions[key] = currentQuestion;
            activeMainQuestions.push(currentQuestion);
          } else if (
            currentQuestion.selectedAnswer === null ||
            currentQuestion.selectedAnswer === undefined ||
            currentQuestion.selectedAnswer[0] === "NA"
          ) {
            // scenario 2: no answer is set, if the id is in the active question list
            // we enable, else we disable
            if (
              activeMainQuestionIds.findIndex(
                id => id === currentQuestion.questionID
              ) > -1
            ) {
              currentQuestion.disabled = false;
              _questions[key] = currentQuestion;
              activeMainQuestions.push(currentQuestion);
            } else {
              // since there is no answer, we do not call this.addActiveQuestions
              // because we don't have an answer to verify
              currentQuestion.disabled = true;
              _questions[key] = currentQuestion;
            }
          } else {
            //scenario 3: we have an actual answer.
            if (currentQuestion.disabled === true) {
            } else {
              activeMainQuestionIds = this.addActiveQuestions(
                currentQuestion,
                activeMainQuestionIds
              );
              currentQuestion.disabled = false;
              _questions[key] = currentQuestion;
              activeMainQuestions.push(currentQuestion);
            }
          }
        }
        mainQuestions.push(currentQuestion); //add all non-slider questions to this array
      }
    });

    // sort slider questions based on key 12a, 12b ...
    Object.keys(subUnOrderedQuestions)
      .sort()
      .forEach(key => {
        subOrderedQuestions[key] = subUnOrderedQuestions[key];
      });

    //create an object for the active slider questions based on the selected answers in the checkbox question
    if (
      checkBoxQuestionKey !== null &&
      _questions[checkBoxQuestionKey].selectedAnswer
    ) {
      const indexofCheckboxAnswers = [];
      _questions[checkBoxQuestionKey].selectedAnswer.forEach(checkboxAnswer => {
        let answerIndex = _questions[checkBoxQuestionKey].answers.findIndex(
          possibleAnswer => possibleAnswer === checkboxAnswer
        );
        if (answerIndex > -1) {
          indexofCheckboxAnswers.push(answerIndex);
        }
      });
      // console.log(indexofCheckboxAnswers)
      indexofCheckboxAnswers.forEach((checkboxIndex, nthAnswer) => {
        const sliderQuestion = {};
        const [key, value] = Object.entries(subOrderedQuestions)[checkboxIndex];
        const question =
          _questions[checkBoxQuestionKey].selectedAnswer[nthAnswer];
        sliderQuestion.question = question;
        sliderQuestion.answers = value.answers;
        unOrderedActiveSubQuestions[key] = sliderQuestion;
      });
    }

    //sort the slider questions based on key 12a, 12b ...
    Object.keys(unOrderedActiveSubQuestions)
      .sort()
      .forEach(key => {
        activeSubQuestions[key] = unOrderedActiveSubQuestions[key];
      });

    return {
      mainQuestions,
      subOrderedQuestions,
      activeMainQuestions,
      activeSubQuestions
    };
  };

  addActiveQuestions = (currentQuestion, activeMainQuestionIds) => {
    let _activeMainQuestionIds = activeMainQuestionIds.splice(0);
    _activeMainQuestionIds.push(currentQuestion.questionID);

    if (
      currentQuestion.selectedAnswer &&
      currentQuestion.selectedAnswer !== null &&
      currentQuestion.selectedAnswer !== undefined
    ) {
      if (
        currentQuestion.answers.findIndex(
          ans => ans === currentQuestion.selectedAnswer[0]
        ) === 0
      ) {
        _activeMainQuestionIds.push(currentQuestion.nextQuestions.option1);
      } else {
        _activeMainQuestionIds.push(currentQuestion.nextQuestions.other);
      }
    }
    return _activeMainQuestionIds;
  };

  /**
   * Event handler for when a radio question answer is selected.
   *
   */
  selectRadioAnswer = (currentQuestionID, answer, nextQuestionID) => {
    let questions = this.state.questions;
    //1. Set answer for questions array
    if (
      questions[currentQuestionID].selectedAnswer === null ||
      questions[currentQuestionID].selectedAnswer === undefined
    ) {
      questions[currentQuestionID].selectedAnswer = [];
    }

    questions[currentQuestionID].selectedAnswer[0] = answer;

    //we need to enable/disable radio questions based on this new answer
    Object.keys(questions).forEach(key => {
      const _key = parseInt(key);
      const _nextQuestionID = parseInt(nextQuestionID);
      const _currentQuestionID = parseInt(currentQuestionID);

      //we ensure to enable the next question based on this answer
      if (_key === _nextQuestionID) {
        questions[key].disabled = false;
      } else if (_key < _nextQuestionID && _key > _currentQuestionID) {
        questions[key].disabled = true;
      }
    });
    this.setupPageData(questions, nextQuestionID);
  };

  /**
   * Event handler for when a radio question answer is selected.
   *
   */
  selectCheckboxAnswer = (currentQuestionID, event) => {
    let questions = this.state.questions;
    let selectedAnswer = event.name;
    let isChecked = event.checked;

    if (
      questions[currentQuestionID].selectedAnswer === null ||
      questions[currentQuestionID].selectedAnswer === undefined
    ) {
      questions[currentQuestionID].selectedAnswer = [];
    }

    if (isChecked === true) {
      questions[currentQuestionID].selectedAnswer.push(selectedAnswer);
    } else {
      questions[currentQuestionID].selectedAnswer = questions[
        currentQuestionID
      ].selectedAnswer.filter(answer => answer !== selectedAnswer);
    }
    this.setupPageData(questions);
  };

  /**
   * Event handler for when a slider is changed
   */
  changeSlider = (value, questionNumber, question, sliderType) => {
    let questions = this.state.questions;
    let slider = questions[questionNumber].find(
      slider => slider.question === question
    );
    const stringValue =
      value === 10 || value === 0 ? "Low" : value === 55 ? "Medium" : "High";
    if (!slider.selectedAnswer) {
      slider.selectedAnswer = {};
    }
    slider.selectedAnswer[sliderType] = stringValue;
    // console.log('slider changed')
    // console.log(questions)
    questions[questionNumber][
      questions[questionNumber].indexOf(slider)
    ] = slider;
    // console.log(questions)
    this.setupPageData(questions);
  };

  /**
   * Determines total percentage of questions answered
   */
  calculateSectionProgress = (activeMainQuestions, activeSubQuestions) => {
    // console.log(activeMainQuestions.length)
    // console.log(activeMainQuestions);
    let answeredQuestions = 0;
    let totalQuestions = 0;

    // percentage complete should include radio, checkbox and slider questions
    // this accounts for radio and checkbox questions
    activeMainQuestions.forEach(question => {
      //   if (
      //     question.selectedAnswer !== null &&
      //     question.selectedAnswer !== undefined
      //   ) {
      if (question.questionType === "checkbox") {
        if (
          question.selectedAnswer !== null &&
          question.selectedAnswer !== undefined &&
          question.selectedAnswer.length !== 0
        ) {
          answeredQuestions++;
        }
      } else if (question.questionType === "radio") {
        if (
          question.selectedAnswer !== null &&
          question.selectedAnswer !== undefined &&
          question.selectedAnswer[0] !== "NA"
        ) {
          answeredQuestions++;
        }
      }
      totalQuestions++;
      //   }
    });

    // this accounts for slider questions
    Object.keys(activeSubQuestions).forEach(activeSubQuestionKey => {
      activeSubQuestions[activeSubQuestionKey].answers.forEach(answer => {
        if (answer.selectedAnswer) {
          if (
            answer.selectedAnswer.likelihood &&
            answer.selectedAnswer.likelihood !== "NA"
          ) {
            answeredQuestions++;
          }
          if (
            answer.selectedAnswer.impact &&
            answer.selectedAnswer.impact !== "NA"
          ) {
            answeredQuestions++;
          }
        }
        // console.log(answer)
      });
      //each slider question counts as 2 question since there are 2 sliders (likelihood & impact)
      totalQuestions +=
        activeSubQuestions[activeSubQuestionKey].answers.length * 2;
    });

    // console.log(answeredQuestions);
    // console.log(totalQuestions);
    let progress = Math.floor(((answeredQuestions / totalQuestions) * 100));
    return progress;
  };

  /**
   * Responsible for rendering the various types of questions we have
   */
  renderQuestions = () => {
    const riskQuestions = [];
    const subQuestions = [];
    const routingData = this.props.location.state;

    //Renders radio type and checkbox questions
    this.state.mainQuestions.forEach((question, questionIndex) => {
      riskQuestions.push(
        <RiskQuestion
          key={questionIndex}
          question={question}
          sectionName={routingData.backendSectionName}
          selectRadioAnswer={this.selectRadioAnswer}
          selectCheckboxAnswer={this.selectCheckboxAnswer}
        />
      );
    });

    //Renders slider questions based on selected options in checkbox question
    Object.keys(this.state.activeSubQuestions).forEach(
      (questionKey, questionIndex) => {
        subQuestions.push(
          <SliderQuestion
            key={questionIndex}
            questionNumber={questionKey}
            question={this.state.activeSubQuestions[questionKey]}
            sectionName={routingData.backendSectionName}
            changeSlider={this.changeSlider}
          />
        );
      }
    );

    return (
      <React.Fragment>
        {riskQuestions}
        <div className="risk__questions">
          <div className="risk__answers">{subQuestions}</div>
        </div>
      </React.Fragment>
    );
  };

  /**
   * Responsible for loading all UI components on page
   */
  renderPageComponents = () => {
    return (
      <div
        style={{
          position: "relative"
        }}
      >
        <div
          className="comp-assessment"
          id="sra-page"
          style={{
            position: "absolute",
            width: "100%"
          }}
        >
          <Row>
            <Col
              md={12}
              style={{
                paddingLeft: "80px",
                paddingRight: "80px"
              }}
            >
              <h3 className="page-title">HIPAA Security Risk Assessment</h3>
              <h3 className="page-subhead subhead">
                Answer each question as best you can. Some questions will be
                skipped (grayed out) based on your preceding response/s. Upon
                completion of all sections, you can generate an assessment
                report.
              </h3>
            </Col>
          </Row>
          <Row>
            <div className="risk__progress">
              <p>
                Section {this.state.sectionNumber}: {this.state.sectionName}
              </p>
              <BorderLinearProgress
                className="risk__linear"
                variant="determinate"
                color="secondary"
                value={parseInt(this.state.sectionProgress, 10)}
              />
              <span>Progress: {this.state.sectionProgress} </span>
            </div>
          </Row>
          <Row>
            <form
              className="risk__container"
              id="risk__form"
              onSubmit={e => e.preventDefault()}
            >
              {this.renderQuestions()}
            </form>
          </Row>
          <Row>
            <NavigationButtons
              nextPage={this.state.nextPage}
              prevPage={this.state.prevPage}
              save={this.saveSectionAnswers}
            />
          </Row>
        </div>
      </div>
    );
  };

  /**
   * Based on what navigation button a user clicked, we either
   * need to render the next section, a previous section or the
   * main SRA page. THis function decides what to load
   */
  renderRedirect = () => {
    if (this.state.redirectNext) {
      return (
        <Redirect
          to={{
            pathname: `/app/assessment/security-risk-assessment/${this.state.nextPage.section
              .toLowerCase()
              .replace(/ /g, "-")}`,
            state: {
              sectionName: this.state.nextPage.section,
              sectionNumber: this.state.sectionNumber + 1,
              backendSectionName: this.state.nextPage.sectionName
            }
          }}
        />
      );
    } else if (this.state.redirectBack) {
      return (
        <Redirect
          to={{
            pathname: "/app/assessment/security-risk-assessment"
          }}
        />
      );
    } else if (this.state.redirectPrev) {
      return (
        <Redirect
          to={{
            pathname: `/app/assessment/security-risk-assessment/${this.state.prevPage.section
              .toLowerCase()
              .replace(/ /g, "-")}`,
            state: {
              sectionName: this.state.prevPage.section,
              sectionNumber: this.state.sectionNumber - 1,
              backendSectionName: this.state.prevPage.sectionName
            }
          }}
        />
      );
    }
  };

  /**
   * it constructs the answer object, calls the SubmitSRASectionAnswer mutation to save the
   * section answers, then redirects to the correct page.
   */
  saveSectionAnswers = async navigationDirection => {
    this.setState({ saving: true });
    let mainAnswers = [];
    let sliderAnswers = [];

    // console.log(this.state.questions)

    mainAnswers = Object.keys(this.state.questions)
      .filter(
        questionKey =>
          this.state.questions[questionKey].questionType &&
          this.state.questions[questionKey].questionType !== "slider"
      )
      .map(questionKey => {
        const question = this.state.questions[questionKey];
        let answerObject = {};

        answerObject.sectionName = question.sectionName;
        answerObject.questionID = question.questionID;
        if (question.questionType === "radio") {
          answerObject.answer = question.selectedAnswer
            ? question.selectedAnswer[0]
            : "NA";
        } else if (question.questionType === "checkbox") {
          answerObject.answer = question.selectedAnswer
            ? question.selectedAnswer
            : [];
        }

        return answerObject;
      });

    sliderAnswers = Object.keys(this.state.questions)
      .filter(questionKey => !this.state.questions[questionKey].questionType)
      .map(questionKey => {
        let sliderQuestions = [];
        this.state.questions[questionKey].forEach(sliderQuestion => {
          let answerObject = {};
          answerObject.sectionName = `${this.state.backendSectionName}:${questionKey}`;
          answerObject.questionID = sliderQuestion.questionID;
          answerObject.likelihood =
            sliderQuestion.selectedAnswer &&
              sliderQuestion.selectedAnswer.likelihood
              ? sliderQuestion.selectedAnswer.likelihood
              : "NA";
          answerObject.impact =
            sliderQuestion.selectedAnswer &&
              sliderQuestion.selectedAnswer.impact
              ? sliderQuestion.selectedAnswer.impact
              : "NA";
          sliderQuestions.push(answerObject);
        });
        return sliderQuestions;
      });

    const answers = {
      sectionName: this.state.backendSectionName,
      answers: mainAnswers.concat(...sliderAnswers),
      progress: parseFloat(this.state.sectionProgress)
    };

    // console.log(answers)
    try {
      await this.props.client.mutate({
        mutation: SubmitSRASectionAnswer(),
        fetchPolicy: "no-cache",
        variables: {
          answers
        }
      });
      if (navigationDirection === "next") {
        this.setState({
          saving: false,
          redirectNext: true,
          redirectBack: false,
          redirectPrev: false
        });
      } else if (navigationDirection === "back") {
        this.setState({
          saving: false,
          redirectNext: false,
          redirectBack: true,
          redirectPrev: false
        });
      } else {
        this.setState({
          saving: false,
          redirectNext: false,
          redirectBack: false,
          redirectPrev: true
        });
      }
    } catch (err) {
      this.setState({
        saving: false
      });
      console.log("Saving Error");
      console.log(err);
    }
  };

  render () {
    //backendSectionName, sectionNumber, sectionName available from location.state object
    const routingData = this.props.location.state;
    return (
      <Container style={{}}>
        <DataLoader>
          {this.renderRedirect()}
          {routingData === undefined ? (
            <Redirect to="/app/assessment/security-risk-assessment/" />
          ) : (
              <Query
                query={GetSRASectionQuestions(routingData.backendSectionName)}
                fetchPolicy={"network-only"}
                onError={e => {
                  if (e.networkError) {
                    if (e.networkError['statusCode'] === 401) {
                      console.log("401 error")
                    }
                  } else {
                    console.log(e.message)
                  }
                }}
                onCompleted={data => {
                  if (data && data.getSRASectionQuestions) {
                    // console.log(data.getSRASectionQuestions);
                    this.setState(
                      {
                        nextPage: data.getSRASectionQuestions.next,
                        prevPage: data.getSRASectionQuestions.prev
                      },
                      () => {
                        this.setupPageData(
                          JSON.parse(data.getSRASectionQuestions.questions),
                          null,
                          routingData
                        );
                      }
                    );
                  } else {
                    this.setState({ pageDataReady: true });
                  }
                }}
              >
                {({ loading, error, data }) => {
                  if (!loading && this.props.dataLoaded) {
                    if (
                      data &&
                      data.getSRASectionQuestions &&
                      this.state.pageDataReady
                    ) {
                      return this.renderPageComponents();
                    } else if (this.state.pageDataReady) {
                      return (
                        <Redirect to="/app/assessment/security-risk-assessment/" />
                      );
                    } else {
                      return <Loader />;
                    }
                  } else if (error) {
                    console.log(`ERROR > ${error.message} `);
                    return null;
                  } else {
                    return <Loader />;
                  }
                }}
              </Query>
            )}
          {this.state.saving && <Saving />}
        </DataLoader>
      </Container>
    );
  }
}

function mapStateToProps (state) {
  return {
    dataLoaded: !state.controlsData.loading
  };
}

const BorderLinearProgress = withStyles({
  root: {
    height: 10,
    backgroundColor: "#4d535d"
  },
  bar: {
    borderRadius: 20,
    backgroundColor: "#5B9EAA"
  }
})(LinearProgress);

function validate (values) { }

export default reduxForm({
  form: "security_risk_assessment",
  validate
})(
  withRouter(
    connect(
      mapStateToProps,
      { signout }
    )(withApollo(SRASectionPage))
  )
);



// WEBPACK FOOTER //
// ./src/components/sra/SRASectionPage.js